export default "__VITE_ASSET__DH2LED3h__"